export default __webpack_public_path__ + "static/media/247uptime-logo.b61336e5.svg";